import { PropsWithChildren } from 'react';

import { QueryClient, QueryClientProvider as TSProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const QueryClientProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return <TSProvider client={queryClient}>{children}</TSProvider>;
};

export default QueryClientProvider;
